// ----------------------------------------------------------------------

export const phoneNumber = [
  '0123456789',
  '0123456789',
  '0123456789',
  '0123456789',
  '0123456789',
  '0123456789',
  '0123456789',
  '0123456789',
  '0123456789',
  '0123456789',
  '0123456789',
  '0123456789',
  '0123456789',
  '0123456789',
  '0123456789',
  '0123456789',
  '0123456789',
  '0123456789',
  '0123456789',
  '0123456789',
  '0123456789',
  '0123456789',
  '0123456789',
  '0123456789',
  '0123456789',
  '0123456789',
  '0123456789',
  '0123456789',
  '0123456789',
  '0123456789',
  '0123456789',
  '0123456789',
  '0123456789',
  '0123456789',
  '0123456789',
  '0123456789',
  '0123456789',
  '0123456789',
  '0123456789',
  '0123456789',
];
